import React from "react";
import VisaCardImg from "../../assets/visa_card.png";
import TelegramBackButton from "../../components/TelegramBackButton";
import { useNavigate } from "react-router-dom";

function Payment() {
  const isHomePage = false;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/order-summary");
  };
  return (
    <>
      <TelegramBackButton isHomePage={isHomePage} />
      <div className="w-full max-w-md bg-white p-6 space-y-6">
        <div
          className="flex justify-between items-center"
          style={{ marginBottom: "10px" }}
        >
          <h2 className="text-lg font-semibold">Credit or Debit card</h2>
          <div className="flex space-x-2">
            <img
              src={VisaCardImg}
              alt="Visa"
              href="visa mastercard"
              className="h-6"
            />
          </div>
        </div>
        <br />

        <div className="flex justify-between w-full text-gray-500 text-sm mb-4 mt-2">
          <p className="font-bold text-black">Payment method</p>
          <p>
            Secure and encrypted <i className="fa-solid fa-lock"></i>
          </p>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">
            Card Holder Name
          </label>
          <input
            type="text"
            placeholder="John Doe"
            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">
            Card Number
          </label>
          <input
            type="text"
            placeholder="1234 5678 9012 3456"
            className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>

        <div className="flex space-x-4">
          <div className="w-1/2">
            <label className="text-sm font-medium text-gray-700">
              Expiry Date
            </label>
            <input
              type="text"
              placeholder="MM/YY"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div className="w-1/2">
            <label className="text-sm font-medium text-gray-700">CVC/CVV</label>
            <input
              type="text"
              placeholder="CVC"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
        </div>

        <div className="flex w-full text-gray-500 text-sm mb-4 mt-2">
          <p className="font-bold text-black">Billing address</p>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">Country</label>
          <select className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
            <option>Select country</option>
            <option>United States</option>
            <option>Canada</option>
            <option>United Kingdom</option>
            <option>Ethiopia</option>
          </select>
        </div>

        <p className="text-xs text-gray-500">
          By completing your purchase, you agree to these{" "}
          <a href="term of use" className="text-purple-600 underline">
            Terms of Use
          </a>
          .
        </p>

        <button
          onClick={handleClick}
          className="w-full flex items-center justify-center space-x-2 bg-[#6938ef] text-white font-semibold py-3 rounded-lg shadow-md transition duration-300"
        >
          <i class="fa-solid fa-credit-card"></i>
          <span>Pay $9.87</span>
        </button>
      </div>
    </>
  );
}

export default Payment;
